import { Map } from 'leaflet';

export const addGridCellsToMap = (map: Map, gridLayerRef: React.MutableRefObject<null>) => {
    const mapBounds = map.getBounds(); // Get the current bounding box (visible area) of the map
    // Check if each grid rectangle intersects with the visible area
    //@ts-ignore
    gridLayerRef.current.eachLayer((rectangle) => {
        const rectangleBounds = rectangle.getBounds();
        if (rectangleBounds.intersects(mapBounds)) {
            rectangle.addTo(map); // Add the rectangle to the map if it intersects with the visible area
        } else {
            rectangle.removeFrom(map); // Remove the rectangle from the map if it's not visible
        }
    });
};
